module.exports = __webpack_public_path__ + "static/WEDDING E&M-280-96360a71685306b096de686ee1e5225b.jpg";